"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./EcommerceCard.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BoundedCardMethods = require("../BoundedCard/BoundedCardMethods");
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _CTASectionMethods = require("../CTASection/CTASectionMethods");
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EcommerceCard = _ref => {
  let {
    content = {},
    contentfulId
  } = _ref;
  const {
    image,
    eyebrow,
    header,
    text,
    Link,
    cardLink,
    cardLabel,
    productPrice,
    productPageLink,
    trialLink,
    hasTopMargin,
    pimContentfulId
  } = content;
  const labelSpacing = hasTopMargin === true || cardLabel ? true : false; // applies 16px top margin if this card or other peer cards have a card label set

  const imageSizes = {
    desktop: {
      width: 352,
      height: 352,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 352,
      height: 352,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 370,
      height: 370,
      ratio: {
        width: 1,
        height: 1
      }
    }
  };
  const currencyIcon = productPrice?.currencyIcon || "$";
  const componentText = text?.data && text?.typename && text?.typename === "ContentfulRichTextContent" ? /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-ecommerce-card__text`
  }, text?.data) : text && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-ecommerce-card__text`,
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(text)
  });
  const renderProductPriceSection = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-ecommerce-card__buy-info"
    }, productPrice?.previousPrice && /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-ecommerce-card__price-prev"
    }, currencyIcon, productPrice?.previousPrice), productPrice?.saving && /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-ecommerce-card__price-saving"
    }, "Save ", currencyIcon, productPrice?.saving), productPrice?.currentPrice && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-ecommerce-card__price-current"
    }, currencyIcon, /*#__PURE__*/_react.default.createElement("span", {
      "data-sb-field-path": "currentPrice"
    }, productPrice?.currentPrice)), /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-ecommerce-card__price-term",
      "data-sb-field-path": "purchaseTerms"
    }, productPrice?.priceTerm && productPrice?.priceTerm), cardLink && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-ecommerce-card__link-holder",
      "data-sb-field-path": "buttonText"
    }, (0, _BoundedCardMethods.renderButton)(cardLink, Link, null, null, null, "ter-ecommerce-card__button")));
  };
  const renderCardImage = image => {
    if (image?.focalPointImage) {
      return /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
        focalPointImage: image?.focalPointImage,
        alt: image?.alt,
        fullHeightWrapper: true,
        imageSizes: imageSizes
      });
    } else {
      return /*#__PURE__*/_react.default.createElement("img", {
        src: image?.url,
        alt: image?.altText || image?.title,
        className: "ter-ecommerce-card__image--not-focused"
      });
    }
  };
  const componentJSX = /*#__PURE__*/_react.default.createElement("div", {
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, cardLabel && /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-ecommerce-card__label",
    "data-sb-field-path": "cardLabel"
  }, cardLabel), (image?.focalPointImage || image?.url) && /*#__PURE__*/_react.default.createElement("figure", {
    role: "none",
    className: "ter-ecommerce-card__image"
  }, renderCardImage(image)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-ecommerce-card__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-ecommerce-card__description`,
    "data-sb-object-id": pimContentfulId ? pimContentfulId : null
  }, eyebrow && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-ecommerce-card__eyebrow"
  }, eyebrow), header && /*#__PURE__*/_react.default.createElement("h4", {
    className: "ter-ecommerce-card__header",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
  }), componentText, productPageLink && (0, _BoundedCardMethods.renderCardLink)(productPageLink, Link, (0, _CTASectionMethods.checkForExternalLink)(productPageLink?.url), null, null, null, "ter-ecommerce-card__product-page-link")), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-ecommerce-card__lower"
  }, trialLink && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-ecommerce-card__trial"
  }, (0, _BoundedCardMethods.renderCardLink)(trialLink, Link, (0, _CTASectionMethods.checkForExternalLink)(trialLink?.url), null, null, null, "ter-ecommerce-card__trial-link")), productPrice && renderProductPriceSection())));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-ecommerce-card ${labelSpacing === true ? "ter-ecommerce-card--with-label" : ""}`
  }, componentJSX);
};
var _default = EcommerceCard;
exports.default = _default;
EcommerceCard.propTypes = {
  content: _propTypes.default.shape({
    image: _propTypes.default.object,
    header: _propTypes.default.string.isRequired,
    subHeader: _propTypes.default.string,
    cardLink: _propTypes.default.shape({
      url: _propTypes.default.string,
      text: _propTypes.default.string.isRequired
    })
  })
};